import { render, staticRenderFns } from "./HomeBk.vue?vue&type=template&id=7b807290&"
import script from "./HomeBk.vue?vue&type=script&lang=ts&"
export * from "./HomeBk.vue?vue&type=script&lang=ts&"
import style0 from "./HomeBk.vue?vue&type=style&index=0&id=7b807290&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports